import { Component, Input } from '@angular/core';
import { BrandingState } from "../../../branding/store/branding.state";
import { TranslatePipe } from '@ngx-translate/core';
import { SafeHtmlPipe } from '../../../utils/pipes/safe-html.pipe';

@Component({
    selector: 'app-doctor-questions',
    templateUrl: './doctor-questions.component.html',
    styleUrls: ['./doctor-questions.component.scss'],
    imports: [TranslatePipe, SafeHtmlPipe]
})
export class DoctorQuestionsComponent {
    @Input() brandingSettings: BrandingState;

    constructor() {
    }
}
